module.exports = __webpack_public_path__ + "img/campsite.f99cb8ad.jpg";